import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/airports`} />
        <meta
          name="description"
          content={
            'Explore airport information and insights on First-Class.com. Find tips, guides, and resources for a seamless airport experience'
          }
        />
        <title>Airports: Explore the World&apos;s Top Airports</title>
      </Head>
      <ArticlesList type="Airports" heading="Airports" />
    </>
  );
}

export default withLayout(TopLists, true);
